export const generateComponentId = () => {
	return Math.random().toString(36);
};
